import {Injectable} from '@angular/core';

declare const VideoPlayer: any;

/** Specifies a video scaling mode. The content is stretched to the surface rendering area. When the surface has the same aspect ratio as the content, the aspect ratio of the content is maintained; otherwise, the aspect ratio of the content is not maintained when video is being rendered. Unlike VIDEO_SCALING_MODE_SCALE_TO_FIT_WITH_CROPPING, there is no content cropping with this video scaling mode. */
const VIDEO_SCALING_MODE_SCALE_TO_FIT = 1;

/** Specifies a video scaling mode. The content is scaled, maintaining its aspect ratio. The whole surface area is always used. When the aspect ratio of the content is the same as the surface, no content is cropped; otherwise, content is cropped to fit the surface. */
const VIDEO_SCALING_MODE_SCALE_TO_FIT_WITH_CROPPING = 2;

@Injectable({
  providedIn: 'root'
})
export class NativeVideoService {

  constructor() {

  }

  public play(path: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      VideoPlayer.play(path, {
          scalingMode: VIDEO_SCALING_MODE_SCALE_TO_FIT, // 이 옵션은 안드로이드에만 해당됨.
        },
        () => resolve(),
        (err) => reject(err)
      );
    });
  }

  public stop(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      VideoPlayer.close(
        () => resolve(),
        (err) => reject(err)
      );
    });
  }
}
